import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

datadogRum.init(<RumInitConfiguration> environment.datadog_env);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
